import { ReactNode } from 'react'
import { RichText } from '../../utils'
import { IExtensibleProps, ILayout } from '../Hero'
import { IProps as ICheckmarks } from '../../elements/CheckMarks/index'
import { IProps as IImage } from '../../elements/Image'
import { IProps as IMediaWithBreakpoint } from 'marketing-site/src/library/elements/MediaByBreakpoint'
export { HeroWithCTA } from './component'

export interface IHeroImage {
  imageRef: IImage
  isBackground?: boolean
  mobileImage?: IImage
}

export interface IVideo {
  video: string
  videoWebm?: string
  mobileVideo?: string
  mobileVideoWebm?: string
  fallbackImage: string
  isBackground?: boolean
  playOnce?: boolean
  autoplay?: boolean
  muted?: boolean
  showControls?: boolean
}

export interface IProps extends IExtensibleProps {
  renderCta1?: () => React.ReactNode
  renderCta2?: () => React.ReactNode
  areCheckmarksBelowCTA?: boolean
  footnote?: RichText
  layout: ILayout
  headlineLargeFont?: boolean
  checkmarks?: ICheckmarks
  media?: IHeroImage | IVideo
  leftAlignMedia?: boolean
  shouldBleedMedia?: boolean
  multimedia?: ReactNode | IMediaWithBreakpoint
}
